<template>
    <main class="l-main">
        <section class="l-section">

            <div class="c-sortable-list c-sortable-list--3-column">
                <div class="c-sortable-list__header">
                    <sortable-list-search
                            :employee-list="listItems"
                            :results-text="$t(i18n.overview.search.results_for)"
                            v-model="search"/>
                    <add-employee-element/>
                </div>

                <div class="c-sortable-list__divider"/>

                <alert-box-danger v-show="generalError">
                    <p>{{$t(i18n.overview.general_error)}}</p>
                </alert-box-danger>

                <div v-if="employeeList.length > 0" class="list-wrapper">
                    <sortable-list-headers :headers="listHeaders" v-model="sort" />
                    <div class="c-sortable-list__content u-animation--fade-in u-animation--fade-in-from-bottom">
                        <ul class="c-sortable-items">
                            <li v-for="employee in employeeList" :key="employee.emailAddress">
                                <sortable-list-item :employee="employee"/>
                            </li>
                        </ul>
                    </div>

                    <div v-if="showAllToggleEnabled" class="c-sortable-list__footer">
                        <button class="c-button-more" @click="showAll">{{$t(i18n.overview.show_more)}}<span class="icon-chevron-down"></span></button>
                    </div>
                </div>
                <div v-else>
                    <div v-show="!generalError" class="c-sortable-list__no-results">
                        <h3>{{$t(i18n.overview.search.no_results_title)}}</h3>
                        <p>{{$t(i18n.overview.search.no_results)}} "{{search}}" {{$t(i18n.overview.search.check_spelling)}}</p>
                        <button @click="backToOverview" class="o-button">{{$t(i18n.form.back_to_overview)}}</button>
                    </div>
                </div>

            </div>
        </section>
    </main>
</template>


<script>
    import {Utils} from "@bvm/core";
    import {
        HEADER_TYPE
    } from "../../constants/constants";
    import {getEmployeesAsList} from "../../api/employee/employee-api";
    import {goToSpecialPage} from "@bvm/core/src/api/specialpage/specialpage.api";

    const i18nBuilder = new Utils.I18n.I18nBuilder('employee')
        .add('overview', b => b.add('show_more')
            .add('role', b => b.add('label').add('employee').add('administrator'))
            .add('header', b => b.add('email').add('role'))
            .add('add_employee_button_title')
            .add('general_error')
            .add('search', b => b.add('placeholder')
                .add('results_for')
                .add('no_results')
                .add('no_results_title')
                .add('check_spelling')))
        .add('form', b => b.add('back_to_overview'))
    export const messageKeys = i18nBuilder.getKeys();

    export default {
        name: 'SortableList',
        components: {
            'alert-box-danger': () => import('../fragment/AlertBoxDanger'),
            'add-employee-element': () => import('./AddEmployeeElement'),
            'sortable-list-item': () => import('./SortableListItem'),
            'sortable-list-headers': () => import('./SortableListHeaders'),
            'sortable-list-search': () => import('./SortableListSearch')
        },
        data() {
            return {
                i18n: i18nBuilder.getData(),
                sort: {
                    field: '',
                    ascending: true
                },
                search: '',
                itemLimit: 10,
                showAllToggleEnabled: true,
                listItems: [],
                generalError: false
            };
        },
        created() {
            const vm = this;
            getEmployeesAsList().then(response => {
                vm.listItems = response.data;
            }).catch(() => {
                vm.generalError = true;
            });
        },
        computed: {
            employeeList() {
                return this.listItems
                    .filter(employee => employee.emailAddress.toLowerCase().includes(this.search.toLowerCase()))
                    .sort((a, b) => this.specifiedFieldComparator(a, b, this.sort.field))
                    .slice(0, this.itemLimit)
            },
            listHeaders() {
                return [
                    {label: this.$t(this.i18n.overview.header.email), type: HEADER_TYPE.EMAIL},
                    {label: this.$t(this.i18n.overview.header.role), type: HEADER_TYPE.ROLE}]
            }
        },
        methods: {
            specifiedFieldComparator(a, b, field) {
                let comparison = a[field] === b[field] ? 0 : a[field] > b[field] ? 1 : -1;
                return this.sort.ascending ? -comparison : comparison;
            },
            showAll() {
                this.itemLimit = this.listItems.length;
                this.showAllToggleEnabled = false;
            },
            backToOverview() {
                goToSpecialPage("ADMIN_OVERVIEW");
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fade-list {
        &-move { transition: all 600ms ease-in-out 50ms }
        &-enter-active { transition: all 300ms ease-out }

        &-leave-active {
            position: absolute;
            z-index: 0;
            left: 0;
            opacity: 0;
        }

        &-enter,
        &-leave-to { opacity: 0 }
        &-enter { transform: scale(0.9) }
    }

</style>